module.exports = __webpack_public_path__ + "img/norway-other-heart-diseases-male.21c54263.png";